import { useState } from 'react';
import UI from '../ui';
import { useNavigate } from 'react-router';

const RegisterPage: React.FC = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState(''); // for reenetering the password
  return (
    <UI.VerticalLayout height="100%" justify="end" gap={60} align="center">
      <img
        style={{ maxWidth: '120px' }}
        alt="logo"
        src="./assets/logo_black.svg"
      />
      <UI.VerticalLayout gap={5} width="100%">
        <UI.Textfield label="Username" value={username} onChange={setUsername} placeHolder="Enter username" />
        <UI.Textfield label="Name" value={name} onChange={setName} placeHolder="Enter your name" />
        <UI.Textfield label="Email" value={email} onChange={setEmail} placeHolder="Enter your email" type="email" />

        <UI.Textfield label="Password" value={password} onChange={setPassword} placeHolder="Enter password" type="password" />
        <UI.Textfield label="Re-enter password" value={password2} onChange={setPassword2} placeHolder="Enter password" type="password" />
        <UI.Button label="Register" onClick={() => navigate('/onboarding')} />

        <UI.Divider label="or register with" />
        <div style={{ paddingRight: '30px', paddingLeft: '30px' }}>
          <UI.HorizontalLayout justify="space-between">
            <UI.SocialButton type="google" onClick={() => {}} />
            <UI.SocialButton type="facebook" onClick={() => {}} />
            <UI.SocialButton type="instagram" onClick={() => {}} />
            <UI.SocialButton type="apple" onClick={() => {}} />
          </UI.HorizontalLayout>
        </div>
      </UI.VerticalLayout>
      <UI.Text>
        Already have an account?
        {' '}
        <UI.TextLink path="/login">Log in</UI.TextLink>
      </UI.Text>
    </UI.VerticalLayout>
  );
};

export default RegisterPage;
